module.exports = __webpack_public_path__ + "img/logo_platingold@2x.1e9c645.png";